import { call, select, put, takeLatest } from 'redux-saga/effects';
import _get from 'lodash/get';
import * as actions from '../actions';
import { CONFIRM_TRANSFER_REQUEST } from '../types';
import { confirmTransferRequestApi } from '../api';

export function* confirmTransferRequestSaga() {
  const { confirmTransferSuccess, confirmTransferFailure } = actions;
  try {
    const {
      Data: { csrfToken, rn },
    } = yield select();

    const params = new URLSearchParams(window.location.search);
    const jwtToken = params.get('token');
    const isApollo = params.get('isApollo');
    const payload = { jwtToken, rn, isApollo };

    const {
      data: { success, message },
    } = yield call(confirmTransferRequestApi, csrfToken, payload);

    if (!success) {
      yield put(confirmTransferFailure(message));
    } else {
      yield put(confirmTransferSuccess());
    }
  } catch (e) {
    yield put(confirmTransferFailure(_get(e, 'response.data.message')));
  }
}

const confirmTransferSaga = [takeLatest(CONFIRM_TRANSFER_REQUEST, confirmTransferRequestSaga)];

export default confirmTransferSaga;
